import { createElementBlock as e, openBlock as r, createStaticVNode as o } from "vue";
const s = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-locker"
};
function a(n, t) {
  return r(), e("svg", s, t[0] || (t[0] = [
    o('<path d="M5.33337 25.3333V6.66667C5.33337 5.19391 6.52728 4 8.00004 4H25.8667C26.3086 4 26.6667 4.35817 26.6667 4.8V22.2857" stroke="#0B6AB7" stroke-width="1.5" stroke-linecap="round" class="svg__stroke--primary-blue-03"></path><path d="M18.6667 13.3333H13.3333M18.6667 13.3333H19.2C19.6419 13.3333 20 13.6915 20 14.1333V17.8667C20 18.3085 19.6419 18.6667 19.2 18.6667H12.8C12.3582 18.6667 12 18.3085 12 17.8667V14.1333C12 13.6915 12.3582 13.3333 12.8 13.3333H13.3333H18.6667ZM18.6667 13.3333V10.6667C18.6667 9.77777 18.1333 8 16 8C13.8667 8 13.3333 9.77777 13.3333 10.6667V13.3333H18.6667Z" stroke="#0AA5FF" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" class="svg__stroke--default-cyan-03"></path><path d="M8 22.6667H26.6667" stroke="#0B6AB7" stroke-width="1.25" stroke-linecap="round" class="svg__stroke--primary-blue-03"></path><path d="M8 28H26.6667" stroke="#0B6AB7" stroke-width="1.25" stroke-linecap="round" class="svg__stroke--primary-blue-03"></path><path d="M8.00004 28.0001C6.52728 28.0001 5.33337 26.8062 5.33337 25.3334C5.33337 23.8606 6.52728 22.6667 8.00004 22.6667" stroke="#0B6AB7" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" class="svg__stroke--primary-blue-03"></path>', 5)
  ]));
}
const k = { render: a };
export {
  k as default,
  a as render
};
